module.exports = __webpack_public_path__ + "static/media/zocaloPvcJ3.4d40aff1.jpg";